import React, { useContext, useEffect, useState } from "react";
import InnerLayout from "../../../components/layouts/inner-layout";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import LoadingSpinner from "../../../components/helper-components/loading-spinner";
import moment from "moment";
import { DataContext } from "../../../components/layouts/main-layout";
import {
  DropListTableAction,
  DropListDashboardAction,
  ViewDropList,
  VoidDropList,
} from "../../../redux/actions/purchase-action";
import DynamicTransactionTable from "../../../components/tables/dynamic-transaction-table";
import BadgesComponent from "../../../components/tables/badges-component";
import TransSummaryComp from "../../../components/helper-components/trans-summary-comp";
import ArrowDownLeftIcon from "../../../assets/icons/sales-icons/arrow-down-left-icon";
import ClockIcon from "../../../assets/icons/sales-icons/clock-icon";
import FilmChartIcon from "../../../assets/icons/sales-icons/film-chart-icon";
import ChartIncreaseIcon from "../../../assets/icons/sales-icons/chart-increase-icon";

const DropListTable = () => {
  const { permissionFn } = useContext(DataContext);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  const [invoiceItems, setInvoiceItems] = useState([]);
  const [dataCount, setDataCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [reload, setReload] = useState(false);
  const [dashboard, setDashboard] = useState({
    received: 0,
    pending: 0,
    progress: 0,
    done: 0,
  });

  const [filterData, setFilterData] = useState({
    sort_by: "",
    sort_order: "",
    selectColumn: "drop_list_no",
    from: "",
    to: "",
    inputValue: "",
    orderStatus: "",
  });

  useEffect(() => {
    dispatch(
      DropListTableAction(
        {
          pageNumber: currentPage,
          pageSize: pageSize,
          filterData,
        },
        onSuccess,
        onError
      )
    );
  }, [currentPage, pageSize, filterData, reload]);

  useEffect(() => {
    dispatch(DropListDashboardAction({}, onDashboardSuccess, () => {}));
  }, [reload]);

  const onSuccess = (data) => {
    setError(false);
    setLoading(false);
    setOrders(data?.data?.dropListTable ?? []);
    setDataCount(data?.data?.totalCount);
  };
  const onError = () => {
    setError(true);
    setLoading(false);
  };
  const onDashboardSuccess = (data) => {
    setDashboard({
      received: data?.data?.received ?? 0,
      pending: data?.data?.pending ?? 0,
      progress: data?.data?.progress ?? 0,
      done: data?.data?.done ?? 0,
    });
  };

  const paginationProps = {
    pageSize: pageSize,
    setPageSize: setPageSize,
    dataCount: dataCount,
    setCurrentPage: setCurrentPage,
    currentPage: currentPage,
  };

  const tableBodyData = orders?.map((item) => {
    return {
      id: item?.drop_list_id,
      drop_list_no: (
        <span className="fw_500 cursor-pointer">
          {item?.drop_list_no ?? "--"}
        </span>
      ),
      cmr_name: item?.cmr_name ?? "--",
      cmr_id: item?.cmr_id ?? "--",
      drop_list_order_status: item?.status ?? "",
      drop_list_status: <BadgesComponent status={item?.status} extra='ly Dropped'/>,
      total_qty: item?.total_qty ?? 0,
      total_bins: item?.total_bins ?? 0,
      dropper_name: item?.dropper_name ?? "--",
      created_date: item?.created_date
        ? moment(item?.created_date).format("DD MMM YYYY")
        : "-",
      updated_date: item?.update_date
        ? moment(item?.update_date).format("DD MMM YYYY")
        : "-",
    };
  });

  const statCards = [
    {
      conClass:
        "bg-[var(--trans-stats-con-green-bg)] rounded-[12px] h-[5.3rem] w-[25%] p-3 flex justify-between",
      label: "Total Drop List Received",
      value: `${dashboard.received}`,
      labelClass:
        "text-[length:var(--trans-stats-con-label-fs)] font-[var(--trans-stats-con-label-fw)] text-[var(--trans-stats-con-label-fg)]",
      valueClass:
        "text-[length:var(--trans-stats-con-value-fs)] font-[var(--trans-stats-con-value-fw)] text-[var(--trans-stats-con-value-fg)] mt-2",
      icon: <ArrowDownLeftIcon />,
    },
    {
      conClass:
        "bg-[var(--trans-stats-con-orange-bg)] rounded-[12px] h-[5.3rem] w-[25%] p-3 flex justify-between",
      label: "Pending",
      value: `${dashboard.pending}`,
      labelClass:
        "text-[length:var(--trans-stats-con-label-fs)] font-[var(--trans-stats-con-label-fw)] text-[var(--trans-stats-con-label-fg)]",
      valueClass:
        "text-[length:var(--trans-stats-con-value-fs)] font-[var(--trans-stats-con-value-fw)] text-[var(--trans-stats-con-value-fg)] mt-2",
      icon: <ClockIcon />,
    },
    {
      conClass:
        "bg-[var(--trans-stats-con-red-bg)] rounded-[12px] h-[5.3rem] w-[25%] p-3 flex justify-between",
      label: "In Progress",
      value: `${dashboard.progress}`,
      labelClass:
        "text-[length:var(--trans-stats-con-label-fs)] font-[var(--trans-stats-con-label-fw)] text-[var(--trans-stats-con-label-fg)]",
      valueClass:
        "text-[length:var(--trans-stats-con-value-fs)] font-[var(--trans-stats-con-value-fw)] text-[var(--trans-stats-con-value-fg)] mt-2",
      icon: <FilmChartIcon />,
    },
    {
      conClass:
        "bg-[var(--trans-stats-con-blue-bg)] rounded-[12px] h-[5.3rem] w-[25%] p-3 flex justify-between",
      label: "Done",
      value: `${dashboard.done}`,
      labelClass:
        "text-[length:var(--trans-stats-con-label-fs)] font-[var(--trans-stats-con-label-fw)] text-[var(--trans-stats-con-label-fg)]",
      valueClass:
        "text-[length:var(--trans-stats-con-value-fs)] font-[var(--trans-stats-con-value-fw)] text-[var(--trans-stats-con-value-fg)] mt-2",
      icon: <ChartIncreaseIcon />,
    },
  ];

  const summaryArray = statCards?.length > 0 ? (
      <div className="px-[24px] pt-[16px] flex gap-5">
        {statCards?.map((sum) => (
          <TransSummaryComp sum={sum} />
        ))}
      </div>
    ) : (
      <></>
    );

  return (
    <InnerLayout permissionFn={permissionFn} module="droplist" list={true} title="Drop List">
      {loading ? (
        <LoadingSpinner />
      ) : error ? (
        <></>
      ) : (
        <DynamicTransactionTable
          canCreateStandAlone={false}
          transaction="Drop List"
          transaction_type="drop_list"
          module="droplist"
          is_checkbox_req={true}
          invoiceItems={invoiceItems}
          setInvoiceItems={setInvoiceItems}
          transactionKey="drop_list"
          ViewAction={ViewDropList}
          deleteAction={VoidDropList}
          tableHeading1={tableHeading1}
          options={[{ value: "purchase_invoice", label: "Purchase Invoice" }]}
          handleSelect={(item) => {
            if (item?.value === "purchase_invoice") {
              navigate(
                `/add-purchase-invoice/${encodeURIComponent(
                  JSON.stringify(invoiceItems)
                )}/droplist?auto&transfer=true`
              );
            }
          }}
          filterSec={true}
          orders={orders}
          setOrders={setOrders}
          tableHeading={tableHeading}
          onClickItemFn={(id) => navigate(`/view-droplist/${id}`)}
          list={true}
          permissionFn={permissionFn}
          path="droplist"
          actionsPermissions={{
            edit: ["draft"],
            print: ["open", "closed"],
            delete: ["draft", "open"],
          }}
          reload={reload}
          setReload={setReload}
          loading={loading}
          setLoading={setLoading}
          label="Drop List"
          setFilterData={setFilterData}
          filterData={filterData}
          paginationProps={paginationProps}
          tableBodyData={tableBodyData}
          placeholder="Search (/)"
          initialFilter={{
            sort_by: "",
            sort_order: "",
            selectColumn: "drop_list_no",
            from: "",
            to: "",
            inputValue: "",
            orderStatus: "",
          }}
          summaryArray={summaryArray}
        />
      )}
    </InnerLayout>
  );
};

export default DropListTable;

const tableHeading1 = [
  { label: "ITEM CODE", value: "item_code" },
  { label: "BATCH NO", value: "item_batch_number" },
  { label: "BIN LOCATION", value: "bin_location_no" },
  { label: "QTY DROPPED", value: "qty_to_drop" },
  { label: "UOM", value: "uom_name" },
];

const tableHeading = [
  {
    label: "DROPLIST NUMBER",
    value: "drop_list_no",
    display: false,
    column: true,
    minWidth: 160,
  },
  {
    label: "VENDOR NAME",
    value: "cmr_name",
    display: false,
    column: true,
    minWidth: 220,
  },
  {
    label: "STATUS",
    value: "drop_list_status",
    display: false,
    column: false,
    minWidth: 130,
  },
  {
    label: "QTY",
    value: "total_qty",
    display: true,
    column: false,
    alignment: "right",
    minWidth: 90,
  },
  {
    label: "BINS",
    value: "total_bins",
    display: true,
    column: false,
    alignment: "right",
    minWidth: 90,
  },
  {
    label: "ASSIGNEE",
    value: "dropper_name",
    display: false,
    column: false,
    minWidth: 160,
  },
  {
    label: "UPDADTED DATE",
    value: "updated_date",
    display: false,
    column: false,
    minWidth: 150,
  },
  {
    label: "CREATED DATE",
    value: "created_date",
    display: false,
    column: false,
    minWidth: 150,
  },
  {
    label: "ACTION",
    value: "actions",
    display: false,
    column: false,
    minWidth: 110,
  },
];
